import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Sidebar from "../../layout/Sidebar";
import Navbar from "../../layout/Navbar";

import { updateSingleProduct } from "../../../actions/singleProductAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllContactMerchandiser } from "../../../actions/contactAction";
import { getAllLocation } from "../../../actions/warehouseAction";
import { getspecificproductvariationForEdit } from "../../../actions/variableProductAction";
import { getAllAttribute } from "../../../actions/attributeAction";
import { getspecificSingleProduct } from "../../../actions/singleProductAction";
import {
  createVariationfromEdit,
  updateVariation,
  deleteVariation,
} from "../../../actions/variableProductAction";
import { getAllTag } from "../../../actions/tagAction";
import { getAllBrand } from "../../../actions/brandAction";
import moment from "moment";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  TreeSelect,
  Divider,
  Drawer,
  Skeleton,
  message,
  Space,
  DatePicker,
  Layout,
  Breadcrumb
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
const { Content } = Layout;

const { Option } = Select;

const SingleProductDetailsTable = ({
  List,
  getAllCategory,
  getAllContactMerchandiser,
  Merchandiser,
  getAllLocation,
  getAllAttribute,
  updateSingleProduct,
  details,
  setUpdatelist,
  settrigger,
  getspecificproductvariationForEdit,
  Attribute,
  Warehouse,
  PreVariations,
  createVariationfromEdit,
  updateVariation,
  deleteVariation,
  tagList,
  getAllBrand,
  brandlist,
  getspecificSingleProduct,
}) => {
  const [formdata, setformdata] = useState(false);
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [reload, setreload] = useState(false);
  const [form] = Form.useForm();
  const updateddata = useRef([]);
  const load = useRef(true);
  const { id } = useParams();

  if (details.live_date != null && details.live_date != undefined) {
    details.live_date = moment(details.live_date);
  }

  useEffect(() => {
    // console.log("useEffect");
    setloading(true)
    getAllTag();
    getAllBrand();
    getAllCategory();
    getAllContactMerchandiser();
    getAllLocation();
    getAllAttribute();
    // asyncCall();
    getspecificSingleProduct(id).then(res => {
      getspecificproductvariationForEdit(id).then((result) => {
        details.Variations = result;
        for (let i = 0; i < details.Variations.length; i++) {
          details.Variations[i].Color = details.Variations[i].Color;
          details.Variations[i].Size = details.Variations[i].Size;
          details.Variations[i].Warehouse = details.Variations[i].Warehouse;
          details.Variations[i].ProductDetails =
            details.Variations[i].ProductDetails.id;
        }
        details.Discount = {
          discount: details.discount,
        };

        details.Discount_type = {
          discount_type: details.discount_type,
        };
        load.current = false;
        form.resetFields();
        updateddata.current = details;

        setformdata(true);
        form.setFieldsValue(details);
        setloading(false)
      });
    })

  }, [reload]);

  const onFinish = (values) => {
    // console.log(values);
    let promises = [];
    if (typeof values.Category != "number") {
      values.Category = values.Category.id;
    }


    if (values.live_date != null) {
      console.log(values.live_date)
      values.live_date = values.live_date.format("YYYY-MM-DD");
    }


    updateSingleProduct(details.id, values).then((result) => {
      for (let Variation in values.Variations) {
        if (typeof values.Variations[Variation].id == "undefined") {
          promises.push(
            createVariationfromEdit(
              details.id,
              values.Variations[Variation],
              details.barcode_code
            )
          );
        } else {
          promises.push(
            updateVariation(
              values.Variations[Variation].id,
              values.Variations[Variation],
              values.Variations[Variation].Color,
              values.Variations[Variation].Size,
              values.Variations[Variation].Warehouse,
              details.barcode_code
            )
          );
        }
      }
      Promise.all(promises).then((result) => {
        message.success("Successfully updated");
        form.resetFields();
        setreload(!reload);
      });
    });
  };



  const renderdata = () => {
    if (!loading) {
      return (
        <>
          <h3>Basic details</h3>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={details}
          >
            <Divider></Divider>
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item
                  name="title"
                  label="Product Name"
                  rules={[
                    { required: true, message: "Please enter product name" },
                  ]}
                >
                  <Input placeholder="Please enter product name" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="name" label="Product Name On Website">
                  <Input placeholder="Please enter product name" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="Category" label="Category">
                  <TreeSelect treeData={List} />
                </Form.Item>
              </Col>
              {/* <Col span={6}>
                <Form.Item
                  name="Brand"
                  label="Brand"
                  rules={[
                    {
                      required: true,
                      message: "please slect a brand",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {brandlist.map((brand) => {
                      return (
                        <Option value={brand.id}>{brand.name}</Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col> */}
              <Col span={6}>
                {/* <Form.Item name="Merchandiser" label="Merchandiser">
                  <TreeSelect treeData={Merchandiser} />
                </Form.Item> */}
                <Form.Item name="live_date" label="Live date">
                  <DatePicker
                    // disabledDate={disabledDate}
                    style={{ width: "100%" }}
                  // onChange={(e) => {
                  //   if (e != null) {
                  //     bill.current.Deliver = e.format("YYYY-MM-DD");
                  //   }
                  //   setCart(true);
                  // }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={4}>
                <Form.Item name="stock_alart_amount" label="Stock Alert Amount">
                  <InputNumber placeholder="Stock Alert Amount" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item name="stock_unit" label="Measurement Unit">
                  <Input placeholder="Measurement Unit" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="Discount">
                  <Input.Group compact>
                    <Form.Item name={"discount_type"} noStyle>
                      <Select>
                        <Option value="%">%</Option>
                        <Option value="$">$</Option>
                      </Select>
                    </Form.Item>
                    <Form.Item name={"discount"} noStyle>
                      <Input style={{ width: "70%" }} placeholder="Discount" />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item name="Tag" label="Tag">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    placeholder="Please select"
                  >
                    {tagList.map((tag) => {
                      return <Option value={tag.id}>{tag.name}</Option>;
                    })}
                  </Select>
                </Form.Item>
              </Col>
              {/* <Col span={6}>
                <Form.Item name="tax" label="VAT">
                  <Input type="number" addonBefore="%" placeholder="VAT" />
                </Form.Item>
              </Col> */}
            </Row>
            <h3>Variations</h3>
            <Divider></Divider>
            <div style={{ backgroundColor: "#f0f2f5", padding: "10px" }}>
              <Form.List name="Variations">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, fieldKey, ...restField }) => (
                      <Row gutter={16}>
                        <Col span={2}>
                          <Form.Item
                            label="ID"
                            {...restField}
                            name={[name, "id"]}
                            fieldKey={[fieldKey, "id"]}
                          >
                            <InputNumber disabled />
                          </Form.Item>
                        </Col>
                        <Col span={3}>
                          <Form.Item
                            label="Color"
                            {...restField}
                            name={[name, "Color"]}
                            fieldKey={[fieldKey, "Color"]}
                          >
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {Attribute[1].terms.map((item) => {
                                return (
                                  <Option value={item.id}>{item.name}</Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={2}>
                          <Form.Item
                            label="Size"
                            {...restField}
                            name={[name, "Size"]}
                            fieldKey={[fieldKey, "Size"]}
                          >
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {Attribute[0].terms.map((item) => {
                                return (
                                  <Option value={item.id}>{item.name}</Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            label="Warehouse"
                            {...restField}
                            name={[name, "Warehouse"]}
                            fieldKey={[fieldKey, "key"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter a warehouse",
                              },
                            ]}
                          >
                            <TreeSelect treeData={Warehouse} />
                          </Form.Item>
                        </Col>
                        <Col span={4} offset={1}>
                          <Form.Item
                            label="Purchase Price"
                            {...restField}
                            name={[name, "purchase_price"]}
                            fieldKey={[fieldKey, "purchase_price"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter a purchase price",
                              },
                            ]}
                          >
                            <Input
                              addonBefore="$"
                              type="number"
                              placeholder="purchase price"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            label="Selling Price"
                            {...restField}
                            name={[name, "selling_price"]}
                            fieldKey={[fieldKey, "selling_price"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter a selling price",
                              },
                            ]}
                          >
                            <Input
                              addonBefore="$"
                              type="number"
                              placeholder="Selling price"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={2}>
                          <Form.Item
                            label="Stock"
                            {...restField}
                            name={[name, "quantity"]}
                            fieldKey={[fieldKey, "quantity"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter a quantity",
                              },
                            ]}
                          >
                            <InputNumber placeholder="Stock Amount" />
                          </Form.Item>
                        </Col>
                        <MinusCircleOutlined
                          onClick={() => {
                            if (details.Variations[name]) {
                              deleteVariation(details.Variations[name].id).then(
                                (res) => {
                                  message.success("Successfully removed");
                                }
                              );
                            }
                            remove(name);
                          }}
                          style={{ margin: "auto" }}
                        />
                      </Row>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add field
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </div>

            <Divider></Divider>
            <h3>Additional Information</h3>
            <Row gutter={16}>
              <Col span={5}>
                <Form.Item name="height" label="Height">
                  <Input type="number" placeholder="Height" addonAfter={"cm"} />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item name="width" label="Width">
                  <Input type="number" placeholder="Width" addonAfter={"cm"} />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item name="weight" label="Weight">
                  <Input
                    type="number"
                    placeholder="Weight"
                    addonAfter={"grams"}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                {/* <Form.Item name="Short_description" label="Short Drescription">
                  <Input.TextArea rows={4} placeholder="please enter Address" />
                </Form.Item> */}
                <Form.Item name="Short_description" label="Short Description">
                  <ReactQuill theme="snow" />
                </Form.Item>
              </Col>

              <Col span={12}>
                {/* <Form.Item name="long_description" label="Long Drescription">
                  <Input.TextArea rows={4} placeholder="HTML code" />
                </Form.Item> */}
                <Form.Item name="long_description" label="Long Description">
                  <ReactQuill theme="snow" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Space>
                  <Form.Item name="is_active" valuePropName="checked" checked>
                    <Checkbox>Active Product !</Checkbox>
                  </Form.Item>
                  <Form.Item name="is_sellable" valuePropName="checked" checked>
                    <Checkbox>Sellable Product !</Checkbox>
                  </Form.Item>
                </Space>
              </Col>
            </Row>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </>
      );
    } else {
      return <Skeleton active />;
    }
  };

  return (
    <>
      <Layout className="window-frame">
        <Sidebar />
        <Layout className="site-layout">
          <Navbar />
          <Content className="main-frame-content">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Products</Breadcrumb.Item>
              <Breadcrumb.Item>{details.title}</Breadcrumb.Item>
              <Breadcrumb.Item>Variations</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame">
              {renderdata()}
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    List: state.category.categorylist,
    tagList: state.tag.taglist,
    brandlist: state.brand.brandlist,
    Merchandiser: state.contacts.contactlistsearchresult,
    Warehouse: state.warehouse.locationlist,
    Attribute: state.attribute.attributelist,
    PreVariations: state.ProductDetails.productdetails,
    details: state.singleProduct.singleproduct,
  };
};

export default connect(mapStateToProps, {
  getAllCategory,
  getAllBrand,
  getAllContactMerchandiser,
  getAllLocation,
  getAllAttribute,
  updateSingleProduct,
  getspecificproductvariationForEdit,
  createVariationfromEdit,
  updateVariation,
  deleteVariation,
  getspecificSingleProduct,
})(SingleProductDetailsTable);
